module.exports = __webpack_public_path__ + "static/media/EmailLogo.3225186a.png";